import type { Operator } from '@whinerp/contracts/rules';
import type { useT } from '../../app/i18n.js';

/**
 * The RuleBuilder's strings, in one place.
 *
 * Six callers means six label objects, and six copies of the operator table
 * would be six chances for "is at least" to become "greater than or equal to"
 * on one screen and not the others. The words a rule is written in are part of
 * whether people can read their own rules back.
 */
export function ruleBuilderLabels(t: ReturnType<typeof useT>) {
  const operatorLabels: Record<Operator, string> = {
    eq: t('rule.op.eq'),
    ne: t('rule.op.ne'),
    lt: t('rule.op.lt'),
    lte: t('rule.op.lte'),
    gt: t('rule.op.gt'),
    gte: t('rule.op.gte'),
    between: t('rule.op.between'),
    contains: t('rule.op.contains'),
    'starts-with': t('rule.op.startsWith'),
    in: t('rule.op.in'),
    'not-in': t('rule.op.notIn'),
    'is-set': t('rule.op.isSet'),
    'is-not-set': t('rule.op.isNotSet'),
  };

  return {
    all: t('rule.all'),
    any: t('rule.any'),
    none: t('rule.none'),
    addCondition: t('rule.addCondition'),
    addGroup: t('rule.addGroup'),
    remove: t('rule.remove'),
    field: t('rule.field'),
    operator: t('rule.operator'),
    value: t('rule.value'),
    and: t('rule.and'),
    or: t('rule.or'),
    summary: (count: string, outcome: string) =>
      t('rule.summary', { values: { count, outcome } }),
    matching: (count: string) => t('rule.matching', { values: { count } }),
    matchingUnknown: t('rule.matchingUnknown'),
    sampleRows: t('rule.sampleRows'),
    tooDeep: (max: string) => t('rule.tooDeep', { values: { max } }),
    operatorLabels,
  };
}
